import React from 'react'
import '../../styles/Diagnostic/DiagnosticEnergy.css'
import { Fade } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticEnergySection1 from '../../assets/diagnostic/diagnostic-energy-section1.jpg'
import diagnosticEnergySection2 from '../../assets/diagnostic/diagnostic-energy-section2.jpg'
import AccordionText from '../Utils/AccordionText'
import Table from '../Utils/Table'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticEnergy() {

    const section3AccordionData = [
        {
            title: "Étape 1 : Prise de contact et collecte des données",
            text: "La première étape consiste à recueillir des informations détaillées sur le bâtiment. Cela inclut des données sur la structure, les systèmes de chauffage, de refroidissement, d’éclairage, et d’isolation."
        }, {
            title: "Étape 2 : Visite technique",
            text: "Un technicien certifié se rend sur le site ou habitation pour une inspection approfondie. Cette visite permet de vérifier les informations collectées et d’identifier des aspects moins évidents mais critiques, tels que les ponts thermiques et les infiltrations d’air."
        }, {
            title: "Étape 3 : Analyse des données",
            text: "Les données collectées sont analysées pour déterminer la consommation énergétique actuelle du bâtiment. Cette analyse permet d’identifier les zones de perte d’énergie et les opportunités d’amélioration. Nous utilisons des logiciels spécialisés pour effectuer cette analyse avec une grande précision."
        }, {
            title: "Étape 4 : Rapport et recommandations",
            text: "Un rapport détaillé est rédigé, incluant les constatations de l’audit et des recommandations spécifiques pour améliorer l’efficacité énergétique. Ce rapport est généralement fourni sous 48 heures après l’audit, permettant aux propriétaires de prendre rapidement des décisions éclairées."
        }
    ]

    const section4Accordion1Data = [
        {
            title: "Isolation thermique :",
            text: "Amélioration de l’isolation : L’isolation est l’un des moyens les plus efficaces pour réduire les pertes de chaleur. Les murs, les toits, et les sols peuvent tous être améliorés pour empêcher la chaleur de s’échapper. Une bonne isolation permet de maintenir une température constante à l’intérieur, réduisant ainsi la consommation d’énergie pour le chauffage et la climatisation."
        }, {
            title: "Types d'isolation :",
            text: <ul><li>Isolation des combles : Utilisation de matériaux comme la laine de verre ou la mousse polyuréthane pour isoler les combles.</li><li>Isolation des murs : Injection de matériaux isolants dans les cavités murales ou application de panneaux isolants sur les surfaces murales.</li><li>Isolation des sols : Utilisation de matériaux isolants sous les planchers pour réduire les pertes de chaleur par le sol.</li></ul>
        }, {
            title: "Systèmes de chauffage et de refroidissement :",
            text: <ul><li>Modernisation des systèmes de chauffage : Remplacer les anciens systèmes de chauffage par des équipements modernes et efficaces peut significativement réduire la consommation d’énergie. Les pompes à chaleur, par exemple, sont beaucoup plus efficaces que les chaudières traditionnelles.</li><li>Pompes à chaleur : Les pompes à chaleur sont des systèmes qui transfèrent la chaleur de l’extérieur vers l’intérieur (en hiver) et de l’intérieur vers l’extérieur (en été). Elles utilisent moins d’énergie que les systèmes de chauffage et de refroidissement conventionnels.</li><li>Chauffe-eau solaires : Les chauffe-eau solaires utilisent l’énergie du soleil pour chauffer l’eau, réduisant ainsi la dépendance aux combustibles fossiles et les coûts énergétiques.</li></ul>
        }, {
            title: "Ventilation : ",
            text: <ul><li>Ventilation mécanique contrôlée (VMC) : Une bonne ventilation est essentielle pour assurer une qualité de l’air intérieur adéquate. Les systèmes de ventilation mécanique contrôlée (VMC) permettent de renouveler l’air intérieur tout en minimisant les pertes d’énergie. Il existe différents types de VMC. VMC Simple Flux : Expulse l’air vicié à l’extérieur et fait entrer de l’air neuf. VMC Double Flux : Récupère la chaleur de l’air vicié pour préchauffer l’air neuf, augmentant ainsi l’efficacité énergétique.</li><li>Éclairage économique : Passer à des solutions d’éclairage à haute efficacité énergétique, comme les lampes LED, peut réduire la consommation d’énergie dédiée à l’éclairage de manière significative. Les LED consomment beaucoup moins d’énergie que les ampoules incandescentes ou fluorescentes et ont une durée de vie plus longue.</li></ul>
        }, {
            title: "Énergies renouvelables : ",
            text: "Intégration des énergies renouvelables : L’intégration de sources d’énergie renouvelable est une étape clé pour améliorer l’efficacité énergétique et réduire l’empreinte carbone d’un bâtiment. Les solutions comprennent : Panneaux solaires photovoltaïques : Convertissent la lumière du soleil en électricité. Chauffe-eau solaires : Utilisent l’énergie solaire pour chauffer l’eau. Éoliennes domestiques : Produisent de l’électricité à partir du vent."
        }
    ]

    const section4Accordion2Data = [
        {
            title: "Réduction des coûts énergétiques",
            text: "L’une des principales motivations pour réaliser un audit énergétique est la réduction des coûts liés à la consommation d’énergie. En optimisant les systèmes et en améliorant l’isolation, les propriétaires peuvent réaliser des économies significatives sur leurs factures énergétiques."
        }, {
            title: "Amélioration du confort",
            text: "Un bâtiment bien isolé et équipé de systèmes efficaces offre un meilleur confort thermique, réduisant les variations de température et améliorant la qualité de vie des occupants."
        }, {
            title: "Valorisation immobilière",
            text: "Les bâtiments avec une meilleure performance énergétique sont souvent plus attractifs sur le marché immobilier. Un audit énergétique et les améliorations qui en résultent peuvent augmenter la valeur de votre propriété."
        }, {
            title: "Contribution à l’environnement",
            text: "En réduisant la consommation d’énergie et les émissions de gaz à effet de serre, les audits énergétiques contribuent de manière significative à la lutte contre le changement climatique."
        }
    ]

    const section5AccordionData = [
        {
            title: "Maison individuelle à Argenteuil :",
            text: <ul><li>Situation initiale : Classée F, avec une consommation énergétique élevée et des factures importantes.</li><li>Interventions proposées : Isolation des combles, remplacement de la chaudière par une pompe à chaleur, installation de fenêtres à double vitrage.</li><li>Résultat : Réduction de 35% de la consommation énergétique, amélioration du confort thermique, passage en classe D.</li></ul>
        }, {
            title: "Immeuble de bureaux à Paris :",
            text: <ul><li>Situation initiale : Consommation excessive due à un système de chauffage vétuste et une mauvaise isolation.</li><li>Interventions proposées : Modernisation du système de chauffage, amélioration de l’isolation des murs extérieurs, installation de panneaux solaires pour l’eau chaude sanitaire.</li><li>Résultats : Diminution de 40% des coûts énergétiques, amélioration de la qualité de l’air intérieur, certification HQE obtenue.</li></ul>
        }
    ]

    const section6AccordionData = [
        {
            title: "Isolation thermique :",
            text: "Amélioration de l’isolation : L’isolation est l’un des moyens les plus efficaces pour réduire les pertes de chaleur. Les murs, les toits, et les sols peuvent tous être améliorés pour empêcher la chaleur de s’échapper. Une bonne isolation permet de maintenir une température constante à l’intérieur, réduisant ainsi la consommation d’énergie pour le chauffage et la climatisation."
        }, {
            title: "Types d'isolation :",
            text: <ul><li>Isolation des combles : Utilisation de matériaux comme la laine de verre ou la mousse polyuréthane pour isoler les combles.</li><li>Isolation des murs : Injection de matériaux isolants dans les cavités murales ou application de panneaux isolants sur les surfaces murales.</li><li>Isolation des sols : Utilisation de matériaux isolants sous les planchers pour réduire les pertes de chaleur par le sol.</li></ul>
        }, {
            title: "Systèmes de chauffage et de refroidissement :",
            text: <ul><li>Modernisation des systèmes de chauffage : Remplacer les anciens systèmes de chauffage par des équipements modernes et efficaces peut significativement réduire la consommation d’énergie. Les pompes à chaleur, par exemple, sont beaucoup plus efficaces que les chaudières traditionnelles.</li><li>Pompes à chaleur : Les pompes à chaleur sont des systèmes qui transfèrent la chaleur de l’extérieur vers l’intérieur (en hiver) et de l’intérieur vers l’extérieur (en été). Elles utilisent moins d’énergie que les systèmes de chauffage et de refroidissement conventionnels.</li><li>Chauffe-eau solaires : Les chauffe-eau solaires utilisent l’énergie du soleil pour chauffer l’eau, réduisant ainsi la dépendance aux combustibles fossiles et les coûts énergétiques.</li></ul>
        }, {
            title: "Ventilation : ",
            text: <ul><li>Ventilation mécanique contrôlée (VMC) : Une bonne ventilation est essentielle pour assurer une qualité de l’air intérieur adéquate. Les systèmes de ventilation mécanique contrôlée (VMC) permettent de renouveler l’air intérieur tout en minimisant les pertes d’énergie. Il existe différents types de VMC. VMC Simple Flux : Expulse l’air vicié à l’extérieur et fait entrer de l’air neuf. VMC Double Flux : Récupère la chaleur de l’air vicié pour préchauffer l’air neuf, augmentant ainsi l’efficacité énergétique.</li><li>Éclairage économique : Passer à des solutions d’éclairage à haute efficacité énergétique, comme les lampes LED, peut réduire la consommation d’énergie dédiée à l’éclairage de manière significative. Les LED consomment beaucoup moins d’énergie que les ampoules incandescentes ou fluorescentes et ont une durée de vie plus longue.</li></ul>
        }, {
            title: "Énergies renouvelables : ",
            text: "Intégration des énergies renouvelables : L’intégration de sources d’énergie renouvelable est une étape clé pour améliorer l’efficacité énergétique et réduire l’empreinte carbone d’un bâtiment. Les solutions comprennent : Panneaux solaires photovoltaïques : Convertissent la lumière du soleil en électricité. Chauffe-eau solaires : Utilisent l’énergie solaire pour chauffer l’eau. Éoliennes domestiques : Produisent de l’électricité à partir du vent."
        }
    ]

    const section7TableData = [
        ["Critère", "Avant audit", "Après audit"],
        [<b>Consommation énergétique</b>, "300 kWh/m²/an", "180 kWh/m²/an"],
        [<b>Facture annuelle</b>, "3 000 €", "1 800 €"],
        [<b>Classe énergétique</b>, "F", "D"],
        [<b>Confort thermique</b>, "Variations importantes de température", "Température stable et agréable"],
        [<b>Qualité de l'air</b>, "Ventilation insuffisante", "Air intérieur de meilleure qualité"]
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Audit énergétique - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Audit énergétique sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Audit énergétique - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Audit énergétique sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/audit-énergétique" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/audit-énergétique" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticEnergy'>
                    <div id='header'>
                        <div id='diagnosticEnergyHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Audit énergétique réglementaire</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='diagnosticEnergySection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticEnergySection1Left'>
                                    <h1 className='sectionTitle'>Optimisation et efficacité avec E5M Diagnostics</h1>
                                    <div className='sectionText'>
                                        L’audit énergétique est un outil essentiel pour évaluer et améliorer la performance énergétique d’un bâtiment. Nous nous engageons à vous fournir des services visant à réduire les coûts énergétiques et l’empreinte carbone, tout
                                        en augmentant la valeur de votre propriété.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticEnergySection1Right'>
                                    <img src={diagnosticEnergySection1} id='diagnosticEnergySection1Image' alt='diagnostic-energy-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticEnergySection2'>
                        <Col sm={6}>
                            <div id='diagnosticEnergySection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={diagnosticEnergySection2} className='diagnosticEnergySection2Image' alt='diagnostic-energy-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticEnergySection2Right'>
                                    <h1 className='sectionTitle'>Importance de l'audit énergétique </h1>
                                    <div className='sectionText'>
                                        Depuis janvier 2022, l’audit énergétique est devenu obligatoire pour la vente des maisons classées F ou G, reflétant l’engagement croissant vers une réduction des émissions de gaz à effet de serre et une meilleure efficacité énergétique.
                                        L’objectif est de comprendre comment l’énergie est consommée dans un bâtiment et de proposer des mesures pour améliorer cette consommation.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticEnergySection3'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Processus d'audit énergétique avec E5M Diagnostics</h1>
                            <div id='diagnosticEnergySection3Accordion' className='sectionAccordionDark'>
                                <Accordion>
                                    {section3AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <Row id='diagnosticEnergySection4'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='diagnosticEnergySection4Left'>
                                    <h1 className='sectionTitle'>Solutions proposées</h1>
                                    <div className='sectionText'>
                                        Les solutions proposées dans le cadre d’un audit énergétique peuvent varier en fonction des besoins spécifiques du bâtiment. Voici quelques exemples courants :
                                    </div>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='diagnosticEnergySection4Right'>
                                    <h1 className='sectionTitle'>Avantages d’un audit énergétique</h1>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion2Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticEnergySection5'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Cas pratique : Exemples d'audits réalisés par E5M Diagnostics</h1>
                            <div className='sectionText'>
                                Pour illustrer l’impact d’un audit énergétique, voici quelques exemples concrets d’audits réalisés par E5M Diagnostics :
                            </div>
                            <div id='diagnosticEnergySection5Accordion' className='sectionAccordionDark'>
                                <Accordion>
                                    {section5AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticEnergySection6'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Cas Pratique : Exemples d'Audits Réalisés par E5M Diagnostics</h1>
                            <div className='sectionText'>
                                Les solutions proposées dans le cadre d’un audit énergétique peuvent varier en fonction des besoins spécifiques du bâtiment. Voici quelques exemples courants :
                            </div>
                            <div id='diagnosticEnergySection6Accordion' className='sectionAccordion'>
                                <Accordion>
                                    {section6AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticEnergySection7'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Tableau comparatif : Avant et après l'audit énergétique </h1>
                            <div id='diagnosticEnergySection7Table' className='sectionTable'>
                                <Table data={section7TableData} />
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticEnergySection8'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>E5M Diagnostics au service de ses clients</h1>
                            <div className='sectionText'>
                                L’audit énergétique est un investissement judicieux pour tout propriétaire souhaitant améliorer l’efficacité énergétique de son bâtiment. Grâce à E5M Diagnostics, nous vous fournissons un service complet et personnalisé, permettant de réaliser des économies d’énergie significatives, d’améliorer le confort et de valoriser votre patrimoine immobilier. Grâce à notre expertise et à nos technologies avancées, nous vous aidons à atteindre vos objectifs de performance énergétique tout en contribuant à la préservation de l’environnement.
                            </div>
                            <div className='sectionText'>
                                Contactez-nous dès aujourd’hui pour planifier votre audit énergétique et commencez à bénéficier de ses nombreux avantages.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticEnergy'>
                    <div id='header'>
                        <div id='diagnosticEnergyHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Audit énergétique réglementaire</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticEnergySection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Optimisation et efficacité avec E5M Diagnostics</h1>
                            <div className='sectionTextMobile'>
                                L’audit énergétique est un outil essentiel pour évaluer et améliorer la performance énergétique d’un bâtiment. Nous nous engageons à vous fournir des services visant à réduire les coûts énergétiques et l’empreinte carbone, tout
                                en augmentant la valeur de votre propriété.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticEnergySection1} id='diagnosticEnergySection1ImageMobile' alt='diagnostic-energy-section1' />
                        </Fade>
                    </div>
                    <div id='diagnosticEnergySection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={diagnosticEnergySection2} className='diagnosticEnergySection2ImageMobile' alt='diagnostic-energy-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Importance de l'audit énergétique </h1>
                            <div className='sectionTextMobile'>
                                Depuis janvier 2022, l’audit énergétique est devenu obligatoire pour la vente des maisons classées F ou G, reflétant l’engagement croissant vers une réduction des émissions de gaz à effet de serre et une meilleure efficacité énergétique.
                                L’objectif est de comprendre comment l’énergie est consommée dans un bâtiment et de proposer des mesures pour améliorer cette consommation.
                            </div>
                        </Fade>
                    </div>
                </div>
                <div id='diagnosticEnergySection3Mobile' className='sectionDarkMobile'>
                    <Fade direction={'left'} duration={500}>
                        <h1 className='sectionTitleMobile'>Processus d'audit énergétique avec E5M Diagnostics</h1>
                        <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                            <Accordion>
                                {section3AccordionData.map((item, index) => {
                                    return (
                                        <AccordionText
                                            key={index}
                                            indexKey={index}
                                            header={item.title}
                                            body={item.text}
                                        />
                                    )
                                })}
                            </Accordion>
                        </div>
                    </Fade>
                </div>
                <div id='diagnosticEnergySection4Mobile'>
                    <Fade direction={'right'} duration={500}>
                        <h1 className='sectionTitleMobile'>Solutions proposées</h1>
                        <div className='sectionTextMobile'>
                            Les solutions proposées dans le cadre d’un audit énergétique peuvent varier en fonction des besoins spécifiques du bâtiment. Voici quelques exemples courants :
                        </div>
                        <div className='sectionAccordionMobile'>
                            <Accordion>
                                {section4Accordion1Data.map((item, index) => {
                                    return (
                                        <AccordionText
                                            key={index}
                                            indexKey={index}
                                            header={item.title}
                                            body={item.text}
                                        />
                                    )
                                })}
                            </Accordion>
                        </div>
                    </Fade>
                    <Fade direction={'right'} duration={500}>
                        <h1 className='sectionTitleMobile'>Avantages d’un audit énergétique</h1>
                        <div className='sectionAccordionMobile'>
                            <Accordion>
                                {section4Accordion2Data.map((item, index) => {
                                    return (
                                        <AccordionText
                                            key={index}
                                            indexKey={index}
                                            header={item.title}
                                            body={item.text}
                                        />
                                    )
                                })}
                            </Accordion>
                        </div>
                    </Fade>
                </div>
                <div id='diagnosticEnergySection5Mobile' className='sectionDarkMobile'>
                    <Fade direction={'left'} duration={500}>
                        <h1 className='sectionTitleMobile'>Cas pratique : Exemples d'audits réalisés par E5M Diagnostics</h1>
                        <div className='sectionTextMobile'>
                            Pour illustrer l’impact d’un audit énergétique, voici quelques exemples concrets d’audits réalisés par E5M Diagnostics :
                        </div>
                        <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                            <Accordion>
                                {section5AccordionData.map((item, index) => {
                                    return (
                                        <AccordionText
                                            key={index}
                                            indexKey={index}
                                            header={item.title}
                                            body={item.text}
                                        />
                                    )
                                })}
                            </Accordion>
                        </div>
                    </Fade>
                </div>
                <div id='diagnosticEnergySection6Mobile'>
                    <Fade direction={'right'} duration={500}>
                        <h1 className='sectionTitleMobile'>Cas Pratique : Exemples d'Audits Réalisés par E5M Diagnostics</h1>
                        <div className='sectionTextMobile'>
                            Les solutions proposées dans le cadre d’un audit énergétique peuvent varier en fonction des besoins spécifiques du bâtiment. Voici quelques exemples courants :
                        </div>
                        <div className='sectionAccordionMobile'>
                            <Accordion>
                                {section6AccordionData.map((item, index) => {
                                    return (
                                        <AccordionText
                                            key={index}
                                            indexKey={index}
                                            header={item.title}
                                            body={item.text}
                                        />
                                    )
                                })}
                            </Accordion>
                        </div>
                    </Fade>
                </div>
                <div id='diagnosticEnergySection7Mobile' className='sectionDarkMobile'>
                    <Fade direction={'left'} duration={500}>
                        <h1 className='sectionTitleMobile'>Tableau comparatif : Avant et après l'audit énergétique </h1>
                        <div id='diagnosticEnergySection7Table' className='sectionTable'>
                            <Table data={section7TableData} />
                        </div>
                    </Fade>
                </div>
                <div id='diagnosticEnergySection8Mobile'>
                    <Fade direction={'right'} duration={500}>
                        <h1 className='sectionTitleMobile'>E5M Diagnostics au service de ses clients</h1>
                        <div className='sectionTextMobile'>
                            L’audit énergétique est un investissement judicieux pour tout propriétaire souhaitant améliorer l’efficacité énergétique de son bâtiment. Grâce à E5M Diagnostics, nous vous fournissons un service complet et personnalisé, permettant de réaliser des économies d’énergie significatives, d’améliorer le confort et de valoriser votre patrimoine immobilier. Grâce à notre expertise et à nos technologies avancées, nous vous aidons à atteindre vos objectifs de performance énergétique tout en contribuant à la préservation de l’environnement.
                        </div>
                        <div className='sectionTextMobile'>
                            Contactez-nous dès aujourd’hui pour planifier votre audit énergétique et commencez à bénéficier de ses nombreux avantages.
                        </div>
                    </Fade>
                </div>
            </MobileView >
        </>


    )

}

export default DiagnosticEnergy